import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, model, signal, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps, FormlyModule } from '@ngx-formly/core';
import { toDateString } from '../../../@core/utils/helper';
import { PhxInputDatepickerComponent } from "../../../shared/components/phx-input-datepicker/phx-input-datepicker.component";

type Props = FormlyFieldProps & { [additionalProperties: string]: any; } & {
  /** only shows input for time *(also sets showTime = true)* */
  timeOnly?: boolean;
  /** displays seconds in the input */
  showSeconds?: boolean;
  /** show inputs for time *(always true if timeOnly = true)* */
  showTime?: boolean;
  /** set value to ***new Date()*** if there is no value in the model/formControl */
  initializeValue?: boolean;
};

@Component({
  selector: 'app-formly-date-picker',
  templateUrl: './formly-date-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    PhxInputDatepickerComponent
  ]
})
export class FormlyDatePickerComponent extends FieldType {
  showTime = signal<boolean>(false);
  timeOnly = signal<boolean>(false);
  showSeconds = signal<boolean>(false);
  readonly = signal<boolean>(false);
  value = model<Date>();
  hideOnSelect = signal<boolean>(true);

  ngOnInit() {
    this.updateProps();

    const props = this.field.props as Props;
    if (props?.initializeValue === true) {
      if (!this.formControl.value) {
        const initial = props?.showTime === true
          ? new Date().toISOString()
          : toDateString(new Date());
        this.formControl.setValue(initial);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // React to prop changes
    if (changes.field && this.field?.props) {
      this.updateProps();
    }
  }

  private updateProps() {
    const props = this.field.props as Props;

    if (props?.timeOnly === true) {
      this.showTime.set(true);
      this.timeOnly.set(true);
    }
    else if (props?.showTime === true || props?.showTime === false)
      this.showTime.set(props?.showTime);

    if (props?.showSeconds === true || props?.showSeconds === false)
      this.showSeconds.set(props?.showSeconds);

    if (props?.readonly === true)
      this.readonly.set(true);

    // For date+time pickers, don't auto-close on selection to allow selecting both date and time
    // For date-only and time-only pickers, keep default behavior (close on selection)
    this.hideOnSelect.set(props?.timeOnly === true || !this.showTime());
  }

  onClear() {
    if (!this.readonly()) {
      this.formControl.setValue(null);
      this.value.set(null);
    }
  }
}